import  './index.less';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getUserInfo } from '../../redux/actions';

class Menus extends Component{
    componentDidMount(){
        this.props.getUserInfo();
    }
    render(){
        const {username, urls,islogin} =  this.props.userInfo; 
        return(
            <div className="menus">
                <span className="logos"></span>
                <div className="menus-nav clearfix">
                    <div className="navs menus-item">
                        <a href="//i360mall.com" target="_blank" rel="noopener noreferrer">360商城</a>
                        <a href="//bbs.360.cn/" target="_blank" rel="noopener noreferrer">360社区</a>
                    </div>
                    <div className="userinfo menus-item">
                    {
                        islogin
                        ?
                        <div>
                            <a  href={urls} target="_blank" rel="noopener noreferrer" >{username}</a> 
                            <a  href="//passport.qiku.com/sso/logout?appid=1010000675&callback=http%3a%2f%2fbbs.360.cn%2fmember.php%3fmod%3dlogging%26action%3dlogout%26formhash%3d5d332a79">退出</a>
                        </div>
                        :
                        <div>
                            <a  href="//bbs.360.cn/member.php?mod=logging&amp;action=login">登录</a>	
                            <a  href="//passport.qiku.com/register?appid=1010000675&callback=https%3a%2f%2fbbs.360.cn%2flogin_sso_web.php">注册</a>	
                        </div>	 
                    }
                     </div>
                </div>
            </div>
        )
    }
}
export default connect(
    state => ({userInfo: state.userInfo}),
    {getUserInfo}
)(Menus);


// WEBPACK FOOTER //
// ./src/component/menus/index.jsx